import React from "react";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import Landing from "./components/landing/Landing";
import Login from "./components/Login/Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const isAuthenticated = localStorage.getItem("authPassword") === "2618";

  return (
    <>
      <ToastContainer style={{ fontSize: 20, width: "400px" }} />

      <Router>
        <Route exact path="/login" render={() => <Login />} />
        <Route
          exact
          path="/"
          render={() =>
            isAuthenticated ? <Landing /> : <Redirect to="/login" />
          }
        />
      </Router>
    </>
  );
}

export default App;


